import {BRUSH_CYCLE, BRUSH_SIZE_CHANGE, ERASE_BOOST_LEVEL_CHANGE, LASSO_CYCLE, TOOL_CHANGE} from '../actions/ControlPanelActions';
import {BRUSH, FREEHAND, INVERSE, LASSO, RECT} from 'rc-canvas/lib/DrawingModes';
import {PAN, ZOOMIN, ZOOMOUT} from 'rc-canvas/lib/ZoomPanModes';
import {BRUSH_SIZES} from '../Constants';
import {nextIndex, prevIndex} from '../utils';
import indexOf from 'lodash/indexOf';

const initState = {
    tool: null,
    shape: FREEHAND,
    brushSize: BRUSH_SIZES[1],
    eraseBoostLevel: -100,
    imageFinishedPopping: null,
};

export function controlPanel(state = initState, action) {
    switch (action.type) {
        case TOOL_CHANGE: {
            const tool = action.tool;
            if ((tool === PAN || tool === ZOOMIN || tool === ZOOMOUT) && tool === state.tool) {
                return {...state, tool: null};
            }
            return {...state, tool, shape: action.shape};
        }
        case BRUSH_SIZE_CHANGE:
            return {...state, brushSize: action.value, tool: BRUSH, shape: FREEHAND};
        case BRUSH_CYCLE: {
            if (state.tool === BRUSH) {
                let brushSize = state.brushSize;
                const idx = indexOf(BRUSH_SIZES, brushSize);
                const nIdx = action.backward ? prevIndex(idx, BRUSH_SIZES.length) : nextIndex(idx, BRUSH_SIZES.length);
                brushSize = BRUSH_SIZES[nIdx];
                return {...state, brushSize};
            } else {
                return {...state, tool: BRUSH};
            }
        }
        case LASSO_CYCLE: {
            let tool = LASSO, shape = state.shape;
            const backward = action.backward;
            if (state.tool === LASSO && state.shape !== RECT) {
                tool = INVERSE;
                shape = backward ? RECT : FREEHAND;
            } else if (state.tool === LASSO && state.shape === RECT) {
                tool = INVERSE;
                shape = backward ? FREEHAND : RECT;
            } else if (state.tool === INVERSE && state.shape !== RECT) {
                tool = LASSO;
                shape = backward ? FREEHAND : RECT;
            } else if (state.tool === INVERSE && state.shape === RECT) {
                tool = LASSO;
                shape = backward ? RECT : FREEHAND;
            }
            return {...state, tool, shape};
        }
        case ERASE_BOOST_LEVEL_CHANGE:
            return {...state, eraseBoostLevel: action.value};
        default:
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/controlPanel.js